export default (date) => {
    // Business operates in Mountain Time (MST/MDT) - always render dates
    // in that zone regardless of the viewer's browser/OS timezone.
    return new Date(date).toLocaleDateString("en-US", {
        timeZone: "America/Denver",
        month: "long",
        day: "numeric",
        year: "numeric"
    });
};
